import { AGENT_CLUSTER, AGENT_MIS_REPORT, DASH_IMG_COORDINATOR } from "@/_constant";
import BusinessDeveloperContent from "./BusinessDeveloperContent";
import type { DashboardCardConfig, DashboardCardConfigOverride } from "./types";

export const DASHBOARD_CARD_CONFIG: {
  default: DashboardCardConfig;
  categories: Record<string, DashboardCardConfigOverride>;
} = {
  default: {
    visibility: "createPost",
    showRating: true,
    showPostsRemaining: true,
    showPlan: true,
    showStatus: true,
    showMis: false,
    renewOnExpiry: true,
    renewAction: { type: "dialog", name: "RENEW_PLAN" },
    knowMore: {
      titleKey: "-",
      title: "-",
      buttonLabelKey: "label.click_to_know_more",
      imageSrc: DASH_IMG_COORDINATOR,
      action: {type : "none"}
    },
    createPost: {
      titleKey: "label.create_post_to_sell_or_rent_your_property",
      title: "Create post to sell or rent your property",
      buttonLabelKey: "label.create_post",
      action: { type: "create-listing" },
    },
    postingsAction: { type: "route", to: "/postings" },
    kpis: [
      {
        id: "leads",
        labelKey: "label.my_leads",
        valueKey: "leads",
        action: { type: "route", to: "/MyLeads" },
      },
      {
        id: "appointments",
        labelKey: "label.my_appointments",
        valueKey: "appointments",
        action: { type: "route", to: "/myappoinments" },
      }
    ],
    extraKpis: []
  },
  categories: {
    "-1": {
      displayCode: "access.customer",
      showRating: false,
      showPostsRemaining: false,
      renewOnExpiry: false,
      showPlan: false,
      showStatus: false,
      showMis: false,
      kpis: [
        {
          id: "leads",
          labelKey: "label.my_leads",
          valueKey: "leads",
          action: { type: "route", to: "/MyLeads" },
        },
        {
          id: "appointments",
          labelKey: "label.my_appointments",
          valueKey: "appointments",
          action: { type: "route", to: "/myappoinments" },
        }
      ],
    },
    "-2": {
      displayCode: "access.business_developer",
      visibility: "knowMore",
      showRating: false,
      showPostsRemaining: false,
      requiresAgreement: true,
      showMis: true,
      content: BusinessDeveloperContent,
      misAction: { type: "route", to: AGENT_MIS_REPORT},
      kpis: [
        {
          id: "leads",
          labelKey: "label.my_leads",
          valueKey: "leads",
          action: { type: "route", to: "/MyLeads" },
        },
        {
          id: "appointments",
          labelKey: "label.my_appointments",
          valueKey: "appointments",
          action: { type: "route", to: "/myappoinments" },
        }
      ],
      extraKpis: [
        {
          id: "onboarding",
          labelKey: "label.onboarding",
          valueKey: "totalOnboarding",
          action: { type: "dialog", name: "ONBOARDING_COUNT" },
        },
        {
          id: "ads",
          labelKey: "label.ads",
          valueKey: "adsCount",
          action: { type: "dialog", name: "ONBOARDING_COUNT" },
        },
        {
          id: "cluster",
          labelKey: "label.agent_cluster",
          valueKey: "agentOnboarding",
          action: { type: "route", to: AGENT_CLUSTER },
        }
      ],
      knowMore: {
        titleKey: "label.how_to_earn_as_coordinator",
        title: "How to earn as a Business Developer?",
        buttonLabelKey: "label.click_to_know_more",
        imageSrc: DASH_IMG_COORDINATOR,
        action: {type : "link", to: "https://www.youtube.com/watch?v=Af8FtiSI08M"}
      },
      referralAction: { type: "drawer", name: "REFERRAL" },
    },
    "-5": {
      displayCode: "access.investor",
      showRating: false,
      showMis: false,
      kpis: [
        {
          id: "leads",
          labelKey: "label.my_leads",
          valueKey: "leads",
          action: { type: "route", to: "/MyLeads" },
        },
        {
          id: "appointments",
          labelKey: "label.my_appointments",
          valueKey: "appointments",
          action: { type: "route", to: "/myappoinments" },
        }
      ],
    },
    "999": {
      displayCode: "label.assignee",
      visibility: "knowMore",
      showPlan: false,
      showRating: false,
      showPostsRemaining: false,
      renewOnExpiry: false,
      knowMore: {
        titleKey: "label.how_to_earn_as_assignee",
        title: "How it works for assignee ?",
        action: { type: "link", to: "https://www.youtube.com/watch?v=Af8FtiSI08M"},
      },
      kpis: [
        {
          id: "leads",
          labelKey: "label.my_leads",
          valueKey: "leads",
          action: { type: "route", to: "/MyLeads" },
        },
        {
          id: "appointments",
          labelKey: "label.my_appointments",
          valueKey: "appointments",
          action: { type: "route", to: "/myappoinments" },
        }
      ],
    },
  },
};
